export default __webpack_public_path__ + "static/media/sub_page_program.19fc18a1.svg";